"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const utils_1 = require("../lib/utils");
const types_1 = require("../lib/types");
const styled_div_1 = __importDefault(require("./styled-div"));
const theme_1 = __importDefault(require("../styles/theme"));
const useStyles = core_1.makeStyles({
    upliftCheckbox: {
        color: theme_1.default.colors.textDefault,
        '&$checked': {
            color: theme_1.default.colors.textLink,
        },
        '&.Mui-focusVisible': {
            outline: theme_1.default.outline,
            outlineOffset: '-9px',
            borderRadius: '12px',
        },
        '&&:hover': {
            backgroundColor: 'transparent',
        },
    },
    checked: {},
});
const Checkbox = ({ id, innerRef, disabled = false, checked, defaultChecked, className, name, onChange = utils_1.noop, onBlur = utils_1.noop, onFocus = utils_1.noop, onClick = utils_1.noop, error = false, label = undefined, ariaLabel = undefined, required, style, }) => {
    types_1.accessibleLabelCheck(ariaLabel, label);
    const classes = useStyles();
    const toggle = (event) => {
        onChange(event.target.checked, event);
    };
    const checkbox = (react_1.default.createElement(Checkbox_1.default, { id: id, ref: innerRef, checked: checked, defaultChecked: defaultChecked, disabled: disabled, name: name, onChange: toggle, onBlurCapture: onBlur, onFocusCapture: onFocus, onClick: onClick, inputProps: {
            // @ts-ignore if ariaLabel is not present, then label is a string
            'aria-label': ariaLabel || label,
            'aria-required': required,
        }, color: "primary", classes: {
            root: classes.upliftCheckbox,
            checked: classes.checked,
        }, required: required, style: {
            color: error ? theme_1.default.colors.error : undefined,
        } }));
    return (react_1.default.createElement(styled_div_1.default, { className: className, "data-testid": "checkbox-root", marginTop: "xxs", style: style },
        react_1.default.createElement(core_1.FormControlLabel, { label: label, control: checkbox })));
};
exports.Checkbox = Checkbox;
exports.default = exports.Checkbox;
